import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromAnyDateToIso, fromAnyDateToZulu } from 'utils/converters/time/from.util';
import { getSchedulerWeekEndSunday, getSchedulerWeekStartMonday, parseSchedulerWeekUrlSegment } from 'utils/date/schedulerWeekBound.util';
import logger from 'utils/logger.util';

const L = logger('parseDateWeek');

const RE_UNCAPTURED = /^\d{2}W\d{4}$/;
const RE_CAPTURED = /^(\d{2})W(\d{4})$/;

const IS = Object.freeze({ valid: false, empty: false, formatted: false });
const DF = Object.freeze({ bgnIso: '', endIso: '', bgnZulu: '', endZulu: '', years: '', weeks: '', is: IS });

const parseDateWeek = (value) => {
  const empty = value === '' || value === null || value === void 1;

  const trimmed = fromAnyToTrimmed(value);
  const valid = fromAnyToBool(trimmed.match(RE_UNCAPTURED));

  const is = { ...IS, empty, valid, formatted: valid };

  try {
    if (!valid || empty) return { ...DF, raw: value, is };

    // can also use moment(trimmed, 'W[W]YYYY')
    const v = value.match(RE_CAPTURED);
    const weeks = v[1];
    const years = v[2];

    const weekStart = parseSchedulerWeekUrlSegment(trimmed);
    if (!weekStart) {
      return { ...DF, raw: value, is };
    }

    const bgn = getSchedulerWeekStartMonday(weekStart);
    const end = getSchedulerWeekEndSunday(weekStart);

    return {
      bgnIso: valid ? fromAnyDateToIso(bgn) : '',
      endIso: valid ? fromAnyDateToIso(end) : '',
      bgnZulu: valid ? fromAnyDateToZulu(bgn) : '',
      endZulu: valid ? fromAnyDateToZulu(end) : '',
      raw: value,
      years,
      weeks,
      trimmed,
      is,
    };
  } catch (e) {
    L.warn('()', e);
    return { ...DF, raw: value, is };
  }
};

export default parseDateWeek;
